// Configuration injectée par /config.js (généré au déploiement, voir docs/DEPLOIEMENT.md).
// Sans configuration, le back-office tourne en MODE DÉMO (données fictives en mémoire).
export interface AppConfig {
  supabaseUrl?: string;
  supabaseAnonKey?: string;
  publicBaseUrl?: string; // ex. https://signatures.bonjourbonsoir.paris
  /** Visuels servis avec la page, utilisés uniquement par le mode démo (URL absolues). */
  demoAssets?: { logo?: string; defaultBanner?: string; campaigns?: string[] };
}

declare global {
  interface Window {
    SIGNATURES_CONFIG?: AppConfig;
  }
}

export const config: AppConfig = window.SIGNATURES_CONFIG ?? {};
export const isDemo = !config.supabaseUrl || !config.supabaseAnonKey;
export const publicBaseUrl = (config.publicBaseUrl || location.origin).replace(
  /\/$/,
  '',
);
